import {createContext} from "react"

const RemisionContext = createContext()

export default RemisionContext;